export default __webpack_public_path__ + "static/media/Padsoles of the Silent Slayer.055e39dc.jpg";